import { LoadType } from "../model/domain/Entity";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { ReceivableStatus } from "../model/domain/ReceivableStatus";
import { ReceivableFund } from "../model/domain/ReceivableFund";
import { Bank } from "../model/domain/Bank";
import { PagedList } from "../model/domain/PagedList";
import { LoadHistory } from "../model/domain/LoadHistory";

@Injectable({
  providedIn: "root",
})
export class TabelaHistoricoCargaService {
  constructor(private http: HttpClient) {}

  GetFiles(
    loadTypeFilter: number = null,
    triggerTypeFilter: number = null,
    startDate: Date = null,
    endDate: Date = null,
    page: number = null,
    pageSize: number = null
  ) {
    const params: any = {};

    if (loadTypeFilter) {
      params.loadTypeFilter = loadTypeFilter;
    }

    if (triggerTypeFilter) {
      params.triggerTypeFilter = triggerTypeFilter;
    }

    if (startDate) {
      params.startDate = startDate.toJSON();
    }

    if (endDate) {
      params.endDate = endDate.toJSON();
    }

    if (page) {
      params.page = page;
    }

    if (pageSize) {
      params.pageSize = pageSize;
    }

    return this.http.get<PagedList<LoadHistory>>(
      `${environment.apiUrls.loads}/load-history`,
      {
        params,
      }
    );
  }
}
